import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import PatientData from '../model/PatientData'
import PatientDataRepository from '../clients/db/PatientDataRepository'
import { AppThunk } from '../store'

interface PatientDataState {
  isLoading: boolean
  isUpdatedSuccessfully: boolean
  patientData: PatientData
}

const initialState: PatientDataState = {
  isLoading: false,
  isUpdatedSuccessfully: false,
  patientData: {} as PatientData,
}

function startLoading(state: PatientDataState) {
  state.isLoading = true
}

const patientSlice = createSlice({
  name: 'patientData',
  initialState,
  reducers: {
    fetchPatientDataStart: startLoading,
    createPatientDataStart: startLoading,
    updatePatientDataStart: startLoading,
    fetchPatientDataSuccess(state, { payload }: PayloadAction<PatientData>) {
      state.isLoading = false
      state.patientData = payload
    },
    createPatientDataSuccess(state) {
      state.isLoading = false
    },
    updatePatientDataSuccess(state, { payload }: PayloadAction<PatientData>) {
      state.isLoading = false
      state.patientData = payload
    },
  },
})

export const {
  fetchPatientDataStart,
  fetchPatientDataSuccess,
  createPatientDataStart,
  createPatientDataSuccess,
  updatePatientDataStart,
  updatePatientDataSuccess,
} = patientSlice.actions

export const fetchPatientData = (id: string): AppThunk => async (dispatch) => {
  dispatch(fetchPatientDataStart())

  const patientData = await PatientDataRepository.search(id)

  var aPatientData = patientData[0]
  if (aPatientData) {
    dispatch(fetchPatientDataSuccess(aPatientData))
  } else {
    dispatch(fetchPatientDataSuccess({} as PatientData))
  }
}

export const createPatientData = (
  patientData: PatientData,
  onSuccess?: (patientData: PatientData) => void,
): AppThunk => async (dispatch) => {
  dispatch(createPatientDataStart())
  const newPatientData = await PatientDataRepository.save(patientData)
  dispatch(createPatientDataSuccess())
  if (onSuccess) {
    onSuccess(newPatientData)
  }
}

export const updatePatientData = (
  patientData: PatientData,
  onSuccess?: (patientData: PatientData) => void,
): AppThunk => async (dispatch) => {
  dispatch(updatePatientDataStart())
  const updatedPatientData = await PatientDataRepository.saveOrUpdate(patientData)
  dispatch(updatePatientDataSuccess(updatedPatientData))
  if (onSuccess) {
    onSuccess(updatedPatientData)
  }
}

export default patientSlice.reducer
